import * as Auth0Service from '../../../services/auth0/Auth0Service';
import { AxiosResponse } from 'axios';
import { UserServiceResponse } from '../user/UserServiceResponse';
import { tryMigrateUser } from '../migration/MigrationService';
import { lookupRegistrationUserWithCaptcha } from '../user/UserService';

const sendOneTimeCodeRequest = async (username: string) => {
  if (await shouldSendOTC(username)) {
    try {
      await Auth0Service.triggerPasswordlessStart(username);
      return true;
    } catch (error) {
      return error.code === 400;
    }
  }
  return false;
};

const shouldSendOTC = async (username: string) => {
  try {
    const userValidationResponse = await lookupRegistrationUserWithCaptcha(username);
    if (isOnlyOneUserForUsername(userValidationResponse)) {
      await tryMigrateUser(username);
      return true;
    }
  } catch (e) {
    await tryMigrateUser(username);
    // Let the customer do a passwordless start if the captcha fails.  We just won't lookup their
    // username.
    return true;
  }
  return false;
};

const isOnlyOneUserForUsername = (userValidationResponse: AxiosResponse<[UserServiceResponse]>) => {
  return (
    typeof userValidationResponse !== 'undefined' &&
    userValidationResponse.data &&
    userValidationResponse.data.length === 1 &&
    userValidationResponse.data[0].email
  );
};

export { sendOneTimeCodeRequest };
